import { tConverter24 } from "../../helpers/utils";
import Style from "./resource-header.module.scss";

const CalendarHeadings = ({ daysOfWeek, Rc_dayHeader, type = null }) => {
  return (
    <div
      className={Style.calendarHeader}
      style={{ backgroundColor: "#ece7fd" }}
    >
      {daysOfWeek.map((day) => (
        <div
          key={day}
          className={`${Style.calendarDayHeader} ${
            Rc_dayHeader && Style.Rc_dayHeader
          }`}
          style={{
            minWidth: "192px",
            width: "192px",
            backgroundColor: "#ece7fd",
          }}
        >
          <span className={`text-md-600 greyStrokeColor`}>
            {type
              ? JSON.parse(localStorage.getItem("settings")).regionalSettings
                  .timeFormat === "hh:mm" && day?.name.length > 4
                ? tConverter24(day.name)
                : day.name
              : day.name}
          </span>
          {day?.date && !type && (
            <p className="text-md-400 greyStrokeColor">{day.date}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default CalendarHeadings;
